module.exports = __webpack_public_path__ + "static/img/1_2_1_1.4ecb3508.jpg";